export default "__VITE_ASSET__CeWBSj8$__"